import * as React from 'react';
const SvgBlock = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <circle cx={8} cy={8.003} r={8} fill="currentColor" />
        <rect x={3.5} y={7.003} width={9} height={2} rx={1} fill="#fff" />
    </svg>
);
export default SvgBlock;
